import { Skeleton } from '@/components/ui/skeleton';

/**
 * Esqueletos de carga del módulo — Etapa 6 Parte B (plan 175, spec 156 §6).
 *
 * ⚖️ **Esqueleto cuando se carga CONTENIDO; ruedita cuando el usuario disparó
 * una ACCIÓN.** Una ruedita centrada en una tabla vacía no dice nada sobre lo
 * que va a llegar; un esqueleto con la forma de las filas sí, y además evita el
 * salto de layout cuando el contenido aparece.
 *
 * Donde el usuario apretó algo y espera el resultado —«Simulando estrategia…»,
 * «Generando informe…»— la ruedita **se queda**: ahí lo que importa es que algo
 * está corriendo, y el texto ya dice qué.
 */

/** Filas de una tabla o lista. */
export function EsqueletoFilas({
  filas = 6,
  className = '',
}: {
  filas?: number;
  className?: string;
}) {
  return (
    <div className={`space-y-px ${className}`} aria-hidden="true">
      {Array.from({ length: filas }).map((_, i) => (
        <div key={i} className="flex items-center gap-4 border-b py-4 last:border-b-0">
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-[38%]" />
            <Skeleton className="h-3 w-[22%]" />
          </div>
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-6 w-14 rounded-full" />
        </div>
      ))}
    </div>
  );
}

/** Tarjetas de resumen, del ancho que le den. */
export function EsqueletoTarjetas({
  tarjetas = 4,
  className = '',
}: {
  tarjetas?: number;
  className?: string;
}) {
  return (
    <div className={`grid gap-3 sm:grid-cols-2 lg:grid-cols-4 ${className}`} aria-hidden="true">
      {Array.from({ length: tarjetas }).map((_, i) => (
        <div key={i} className="rounded-xl border p-4 space-y-3">
          <Skeleton className="h-3 w-2/3" />
          <Skeleton className="h-7 w-1/2" />
          <Skeleton className="h-3 w-3/4" />
        </div>
      ))}
    </div>
  );
}

/**
 * El aviso accesible que acompaña a cualquiera de los dos. El esqueleto es
 * decorativo (`aria-hidden`), así que sin esto un lector de pantalla no tendría
 * forma de saber que la pantalla está cargando.
 */
export function AvisoCargando({ children = 'Cargando…' }: { children?: string }) {
  return (
    <span role="status" aria-live="polite" className="sr-only">
      {children}
    </span>
  );
}
